var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"highlight_number"},[_c('div',{staticClass:"highlight_number__title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"highlight_number__value"},[_vm._v(_vm._s(_vm._f("numberWithK")(_vm.value)))])])}
var staticRenderFns = []

export { render, staticRenderFns }